<template>
  <div id="addStreamProxy" >
    <el-dialog
      title="添加内容"
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div id="shared" style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="streamProxy" :rules="rules" :model="proxyParam" label-width="140px" >
              <el-form-item label="标题" prop="name">
                <el-input v-model="proxyParam.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="排序" prop="app">
                <el-input v-model="proxyParam.app" clearable></el-input>
              </el-form-item>
              <el-form-item label="类别" prop="stream">
                <el-input v-model="proxyParam.stream" clearable></el-input>
              </el-form-item>
              <el-form-item label="封面" prop="url">
                <el-input v-model="proxyParam.url" clearable></el-input>
              </el-form-item>
              <el-form-item label="正文" prop="src_url">
                <el-input v-model="proxyParam.src_url" clearable></el-input>
              </el-form-item>
              <el-form-item label="链接" prop="timeout_ms">
                <el-input v-model="proxyParam.timeout_ms" clearable></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="gbId">
                <el-input v-model="proxyParam.gbId" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <div style="float: right;">
                  <el-button type="primary" @click="onSubmit('streamProxy')">立即创建</el-button>
                  <el-button @click="close">取消</el-button>
                </div>
              </el-form-item>
            </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import MediaServer from './../service/MediaServer'
// import StreamProxyList from './../StreamProxyList'


export default {
  name: "streamProxyEdit",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      // listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      // dialogLoading: false,
      // platformList: [],
      // mediaServer: new MediaServer(),
      proxyParam: {
          name: '',
          // type: "default",
          app: '',
          stream: '',
          url: "",
          src_url: '',
          timeout_ms: '',
          // ffmpeg_cmd_key: null,
          gbId: '',
          // rtp_type: null,
          // enable: true,
          // enable_hls: true,
          // enable_mp4: false,
          // platformGbId: null,
          // mediaServerId: "auto",
      },
      // mediaServerList:{},
      // ffmpegCmdList:{},

      rules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        app: [{ required: true, message: "请输入排序", trigger: "blur" }],
        stream: [{ required: true, message: "请输入类别", trigger: "blur" }],
        url: [{ required: true, message: "请输入封面", trigger: "blur" }],
        src_url: [{ required: true, message: "请输入正文", trigger: "blur" }],
        timeout_ms: [{ required: true, message: "请输入链接", trigger: "blur" }],
        gbId: [{ required: true, message: "请输入状态", trigger: "blur" }],
      },
    };
  },
  mounted(){

  },
  methods: {


    openDialog () {
      this.showDialog = true;
      // this.listChangeCallback = callback;
      // if (proxyParam != null) {
      //   this.proxyParam = proxyParam;
      // }

      // let that = this;
      // this.$axios({
      //   method: 'get',
      //   url:`/api/platform/query/10000/0`
      // }).then(function (res) {
      //   that.platformList = res.data.list;
      // }).catch(function (error) {
      //   console.log(error);
      // });
      // this.mediaServer.getMediaServerList((data)=>{
      //   this.mediaServerList = data;
      // })
    },
    // mediaServerIdChange:function (){
    //   let that = this;
    //   if (that.proxyParam.mediaServerId !== "auto"){
    //     that.$axios({
    //       method: 'get',
    //       url:`/api/proxy/ffmpeg_cmd/list`,
    //       params: {
    //         mediaServerId: that.proxyParam.mediaServerId
    //       }
    //     }).then(function (res) {
    //       that.ffmpegCmdList = res.data.data;
    //     }).catch(function (error) {
    //       console.log(error);
    //     });
    //   }

    // },

    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this
          let fromData = {
            title: this.proxyParam.name,
            sort: this.proxyParam.app,
            category: this.proxyParam.stream,
            fileUrl: this.proxyParam.url,
            content: this.proxyParam.src_url,
            url: this.proxyParam.timeout_ms,
            status: this.proxyParam.gbId,
          }
          this.$axios({
            method: 'post',
            url:`api/content/add`,
            data: fromData
          }).then(function (res) {
            console.log(res);
            if (res.status == 200) {
              that.$message.success('添加成功')
              that.showDialog = false
              console.log(that);
              that.$emit('queryList',111)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // onSubmit: function () {
    //   this.dialogLoading = true;
    //   var that = this;
    //   that.$axios({
    //     method: 'post',
    //     url:`/api/proxy/save`,
    //     data: that.proxyParam
    //   }).then(function (res) {
    //     that.dialogLoading = false;
    //     if (typeof (res.data.code) != "undefined" && res.data.code === 0) {
    //       that.$message({
    //         showClose: true,
    //         message: res.data.msg,
    //         type: "success",
    //       });
    //       that.showDialog = false;
    //       if (that.listChangeCallback != null) {
    //         that.listChangeCallback();
    //         that.dialogLoading = false;
    //       }
    //     }
    //   }).catch(function (error) {
    //     console.log(error);
    //     this.dialogLoading = false;
    //   });
    // },
    close(){
      this.showDialog = false;
      this.proxyParam.name = ''
      this.proxyParam.app = ''
      this.proxyParam.stream = ''
      this.proxyParam.url = ''
      this.proxyParam.src_url = ''
      this.proxyParam.timeout_ms = ''
      this.proxyParam.gbId = ''

      // this.dialogLoading = false;
      this.$refs.streamProxy.resetFields();
    },
    // deviceGBIdExit: async function (deviceGbId) {
    //   var result = false;
    //   var that = this;
    //   await that.$axios({
    //     method: 'post',
    //     url:`/api/platform/exit/${deviceGbId}`
    //   }).then(function (res) {
    //     result = res.data;
    //   }).catch(function (error) {
    //     console.log(error);
    //   });
    //   return result;
    // },
    // checkExpires: function() {
    //   if (this.platform.enable && this.platform.expires == "0") {
    //     this.platform.expires = "300";
    //   }
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/StreamProxyEdit.vue